import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { useAuthContext } from 'src/auth/hooks';
import { useNavigate } from 'src/hooks/use-navigate';

export const useEnsurePlatformIdInSearchParams = () => {
  const { platformId, authenticated } = useAuthContext();
  const { pathname, hash } = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticated) return;
    if (!platformId) return;

    if (searchParams.get('platform_id')) return;
    const next = new URLSearchParams(searchParams);
    next.set('platform_id', platformId);
    navigate(`${pathname}?${next.toString()}${hash}`, { replace: true });
  }, [authenticated, platformId, pathname, hash, searchParams, navigate]);
};
